module.exports = ReactDom;


//////////////////
// WEBPACK FOOTER
// external "ReactDom"
// module id = 3
// module chunks = 0